import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { REDIRECT_QUERY_NAME } from '~/components/ModalDeliveryAddress/constants';
import { useModal } from '~/hooks/useModal';
import { userStore } from '~/stores';
import { getAddressModalType } from '~/utils/addressModal';

interface UseNavigateCartProps {
  source?: string;
  withReplace?: boolean;
  beforeNavigate?: () => void;
  afterNavigate?: () => void;
}

const useNavigateCart = (props?: UseNavigateCartProps) => {
  const { beforeNavigate, afterNavigate, source, withReplace } = props || {};
  const navigate = useNavigate();
  const { openModal } = useModal();

  return useCallback(() => {
    // The destination is chosen at checkout, so the cart never asks for one.
    if (!company.addressSelectedAtCheckout && !userStore.deliveryAddress) {
      openModal(getAddressModalType(), source, {
        [REDIRECT_QUERY_NAME]: '/cart',
      });
      return;
    }

    beforeNavigate?.();
    navigate('/cart', { replace: withReplace });
    afterNavigate?.();
  }, [beforeNavigate, afterNavigate, source, navigate, openModal]);
};

export default useNavigateCart;
